import {ReactElement} from 'react';
import {SortableColumn} from '../../common';

export type NewProviderUserMutationInput = {
    email: string;
    firstName: string;
    lastName: string;
    providerGuid: string;
    clientPlacementAccess: boolean;
    clientReportAccess: boolean;
    providerMetricsAccess: boolean;
    rosterAccess: boolean;
    auditLogAccess: boolean;
    contactEditAccess: boolean;
    contactReadAccess: boolean;
    userManagementAdminAccess: boolean;
    active: boolean;
}

export type ProviderUserImportInput = {
    email: string;
    isEmailValid?: boolean;
    firstName: string;
    isFirstNameValid?: boolean;
    lastName: string;
    isLastNameValid?: boolean;
    referralManagementAccess: boolean;
    clientCareAccess: boolean;
    providerMetricsAccess: boolean;
    rosterAdministrationAccess: boolean;
    userManagementAccess: boolean;
    auditLogAccess: boolean;
    contactEditAccess: boolean;
    contactReadAccess: boolean;
}

export type ProviderUserMutationImportInput = {
    providerGuid: string;
    imports: ProviderUserImportInput[];
}

export type ImportUserRequestInfo = {
    guid: string;
    providerName: string;
    createdDate: string;
    total: number;
    created: number;
    updated: number
    failed: number;
    progressing: number;
}

export type ProviderUserImportInfo = {
    email: string;
    firstName: string;
    lastName: string;

    referralManagementAccess: boolean;
    clientCareAccess: boolean;
    providerMetricsAccess: boolean;
    rosterAdministrationAccess: boolean;
    userManagementAccess: boolean;
    auditLogAccess: boolean;
    contactEditAccess: boolean;
    contactReadAccess: boolean;

    importStatus: number;
    oktaApiError: string;
}

export const ImportStatusNumToString = new Map<number, string>([
    [202, "In Progress"],
    [102, "In Progress"],
    [201, "Created"],
    [205, "Updated"],
    [422, "Error"],
])

export type BaseProviderUserInfo = {
    oktaId: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    status: string;
    providerGuid: string;
    providerName: string;
    userManagementAdminAccess: boolean;
};
export type FullProviderUserInfo = BaseProviderUserInfo & {
    clientPlacementAccess: boolean,
    clientReportAccess: boolean,
    providerMetricsAccess: boolean,
    rosterAccess: boolean,
    auditLogAccess: boolean,
    contactEditAccess: boolean,
    contactReadAccess: boolean,
    userManagementAdminAccess: boolean,
    bhpnAdmin: boolean;
};


export type BaseBhpnAdminInfo = {
    oktaId: string;
    username: string;
    email: string;
    firstName: string;
    lastName: string;
    status: string;
}

export type CursorBasedPage<T> = {
    items: Array<T>;
    nextPageCursor: string | null;
};

export type SortableProviderUserField = Pick<BaseProviderUserInfo, "providerName" | "email" | "firstName" | "lastName" | "status" | "userManagementAdminAccess">;

export type UserManagementColumns = Array<SortableColumn<SortableProviderUserField> & {
    isUnsortable?: boolean;
    render?: (val: any) => ReactElement | string;
    maxWidth?: string;
}>;
